import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { VerificationService } from '../../../Model/Verification/verification.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pan-kyc',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pan-kyc.component.html',
  styleUrl: './pan-kyc.component.scss'
})
export class PanKYCComponent {
  isDisabled: boolean = false;
  @Input() EmpMasterId: number = 0;
  @Input() EmpType: String = '';
  @Input() PANNo: String = '';
  PanDetail = {
    PANNo: null as any,
    PANVerificationID: null,
  }

  ReturnDetail = {
    PANVerificationID: null,
    PANVerificationStatus: null as any,
    PANNo: null,
    NameAsPerPAN: null,
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private verification: VerificationService,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService
  ) { }

  ngOnInit() {
    if (this.PANNo != null && this.PANNo != "") {
      this.PanDetail.PANNo = this.PANNo;
    }
  }

  Verification(form: any) {
    if (form.valid) {
      this.isDisabled = true;
      this.PanAadharBankDuplicate('CheckPAN', this.PanDetail.PANNo);
    } else {
      form.submitted = true;
    }
  }

  Confirm() {
    this.activeModal.close(this.ReturnDetail);
  }

  PanAadharBankDuplicate(SelectType: any, CheckValue: any) {
    this.isDisabled = true;
    this.employeeRegistration.PanAadharBankDuplicate({ CheckCompanyWise: true, SelectType: SelectType, FormType: this.EmpType, CheckValue: CheckValue, EmpMasterID: this.EmpMasterId }).subscribe({
      next: (response2) => {
        if (response2.Error_Code == '0') {
          if (SelectType == 'CheckPAN') {
            this.verification.VerifyPan({ 'PanNumber': this.PanDetail.PANNo }).subscribe({
              next: (response) => {
                this.SaveVerification('PAN Card', this.PanDetail.PANNo, JSON.stringify(response), response.transaction_status == 1 ? true : false);
                if (response.transaction_status == 1) {
                  this.ReturnDetail.PANNo = response.data.pan_number;
                  this.ReturnDetail.NameAsPerPAN = response.data.name;
                } else {
                  this.toast.show({ message: response.response_msg, type: toastTypeEnum.warning });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: response2.Error_Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }

      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
        return "";
      },
    });
  }

  SaveVerification(mVerificationType: string, mRequest: any, mResponse: any, Store: any) {
    this.employeeRegistration.SaveVerification({ mVerificationType: mVerificationType, mRequest: mRequest, mResponse: mResponse, EmpMasterId: this.EmpMasterId }).subscribe({
      next: (response) => {
        if (mVerificationType == 'PAN Card' && Store) {
          this.PanDetail.PANVerificationID = response.mVerificationID;
          this.ReturnDetail.PANVerificationID = response.mVerificationID;
          this.ReturnDetail.PANVerificationStatus = 'Verified';
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  close() {
    this.activeModal.close();
  }
}
